module.exports = __webpack_public_path__ + "static/media/corona-full.09c1bfc0.png";